/*
Purpose: Single page hosting both Activity Year Level and Student Year Level
         as separate tabs. Neither underlying component's logic is touched -
         this only composes them.
Project: TCMS
*/

import React, { useState } from 'react';
import { Tabs, Tab, Card } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';

import YearLevelList from './ListActivityYearLevel';
import StudentYearLevelList from './ListStudentYearLevel';

const YearLevelTabs = () => {

  const [activeTab, setActiveTab] = useState('studentYearLevel');

  return (
    <div className="page-wrapper">
      
        <div className="mb-3 d-flex justify-content-start align-items-center">
          <div>
            <h5 className='page-title'>Year Level </h5>

            <div role="presentation" >
              <Breadcrumbs aria-label="breadcrumb" className='my-breadcrumbs'>
              <NavLink underline="hover" color="inherit" to='/admin/admin-list'> Home</NavLink>
                <Typography color="text.primary">Year Level</Typography>
              </Breadcrumbs>
            </div>
          </div>
        </div>
        <Card className='my-card p-1 bg-white'>
      <Tabs
        id="year-level-tabs"
        activeKey={activeTab}
        onSelect={(key) => setActiveTab(key)}
        className="my-tabs"
      >
        <Tab eventKey="studentYearLevel" title="Student Year Level">
          {activeTab === 'studentYearLevel' && <StudentYearLevelList />}
        </Tab>
         <Tab eventKey="activityYearLevel" title="Activity Year Level">
          {activeTab === 'activityYearLevel' && <YearLevelList />}
        </Tab>
      </Tabs>
      </Card>
    </div>
  );
};

export default YearLevelTabs;